import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { Col, Container, Row } from '@yme/atoms/grid';
import { RichText } from '@yme/atoms/rich-text';
import { CookieButtons } from '@yme/components/Cookies/CookieButtons';
import { IndentWrapper } from '@yme/components/Separator';
import { useWindowSize } from '@yme/hooks/index';
import { getRTL } from '@yme/selectors/common';
import { useTranslation } from '@yme/services/i18n';
import { colorCoreBlack900Base } from '@yme/tokens/colors';
import { FlexWrapper } from '@yme/tokens/flexTokens';
import Accordion from '../../Accordion';
import { allowCookies } from '../helpers';
import { CookieContainerStyled, DescriptionContainerStyled, TitleStyled } from './styled';
export function CookieManagement(props) {
    const { isRemoveBottomIndent, description } = props;
    const { isMobileView } = useWindowSize();
    const isRightToLeft = useSelector(getRTL);
    const { t } = useTranslation();
    const allowCookiesHandler = useCallback((isAllow) => {
        allowCookies(isAllow);
    }, []);
    if (!props) {
        return null;
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(IndentWrapper, { isRemoveBottomIndent: isRemoveBottomIndent },
            React.createElement(Container, null,
                React.createElement(Row, { mt: "24px", mdMt: "24px", lgMt: "48px" },
                    React.createElement(Col, { lg: 12, md: 8 },
                        React.createElement(CookieContainerStyled, { isRightToLeft: isRightToLeft },
                            React.createElement(DescriptionContainerStyled, null,
                                React.createElement(TitleStyled, null, t('cookies_ourCookies_header')),
                                React.createElement(RichText, { text: description, paragraphTextColor: colorCoreBlack900Base })),
                            React.createElement(Accordion, { ...props, hasContainerPadding: false, isInCookieManagement: true, isRemoveBottomIndent: true })),
                        React.createElement(FlexWrapper, { flexDirection: isMobileView ? 'column' : 'row', justifyContent: "center", gap: "16px", mt: isMobileView ? '40px' : '48px' },
                            React.createElement(CookieButtons, { allowCookiesHandler: allowCookiesHandler, buttonWidth: "auto" }))))))));
}
